<div class="row p-3 wccard">
  <div class="w-100">
    <div class="d-flex aling-item-center">

      <div class="d-flex justify-content-center align-items-center"
        style="width: 57px; height: 57px; background-color: #D9D9D9; border-radius: 50%;">
        <span class="f-28 font-weight-600">{{ProfileDetails?.firstname.charAt(0) | titlecase}}</span>
      </div>

      <div class="ml-3">

        <div class="d-flex align-items-center mb-1">
          <span class="f-20 font-weight-600" style="color: #484B59;">{{ProfileDetails?.firstname | titlecase}} {{ProfileDetails?.lastname | titlecase}}</span>

          <!-- <span class="ml-3">
            <i style="font-size: 14px; font-weight: 400; color: #3049BE;" class="fa-brands fa-linkedin"></i>
          </span> -->

          <div class="d-flex ml-4 p-1" style="background-color: #FEFE9D66; border-radius: 2px;">
            <div class="d-flex justify-content-center align-items-center"
              style="width: 13px; height: 13px; border-radius: 1px; background-color: #FDFD6868;">
              <i class="fa-solid fa-stars" style="font-size: 8px; font-weight: 900; color: #EBEB4F;"></i>
            </div>
            <span class="ml-1 f-12 font-weight-400" style="color: #484B59;">{{currentPlanDetails?.paymentplanname | titlecase}}</span>
          </div>
        </div>

        <span class="f-16 font-weight-500" style="color: #484B59;"> {{ProfileDetails?.designation | titlecase}} in {{ProfileDetails?.company | titlecase}}</span>
      </div>

    </div>
  </div>
</div>


<div class="row wccard p-3" style="margin-top: 4px;">
  <div class="col">
    <div class="d-flex justify-content-between align-items-center">
      <span class="f-16 font-weight-600 m-0" style="color: #484B59;">Basic Information</span>
      <span class="trx pointer text-bluex d-flex gap-3">
        <span
          *ngIf="(ProfileDetails && ProfileDetails.registeredvia !== 'google' && ProfileDetails.registeredvia !== 'linkedin')"
          (click)="changepasswordmodal()">
          <i class="fa-regular fa-lock-keyhole"></i> Reset Password
        </span>
        <span class="ml-4" (click)="EditProfileDetails()">
          <i class="fas fa-edit"></i> Edit
        </span>
      </span>
    </div>

    <div class="row">
      <div>
        <div *ngFor="let item of [
            { label: 'First Name', value: ProfileDetails?.firstname | titlecase },
            { label: 'Last Name', value: ProfileDetails?.lastname | titlecase },
            { label: 'Designation', value: ProfileDetails?.designation },
            { label: 'Company Name', value: ProfileDetails?.company },
            { label: 'Phone', value: ProfileDetails?.extn },
            { label: 'Email', value: ProfileDetails?.loginemail },
            { label: 'Region Preference', value: ProfileDetails?.preferredsearchcontinent | titlecase }
          ]">
          <div class="d-flex justify-content-between">
            <span class="plan-details-name">{{ item.label }}</span>
            <span class="plan-details-value">{{ item.value ? item.value : '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<!-- <app-teaminvite></app-teaminvite> -->
